import React, { useState } from "react";
import EndemicityMap from "./Maps/EndemicityMap"
import WaterBodiesMap from "./Maps/WaterBodyMap";
import WeatherMap from "./Maps/WeatherMap";
export const spinnerOverlayStyle = {
  position: "absolute",
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

export const spinnerStyle = {
  width: "45px",
  height: "45px",
  border: "3px solid #f3f3f3",
  borderTop: "3px solid #024795",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};
export default function MapNavigator() {
  const [activeMap, setActiveMap] = useState("factor"); // factor | endemicity | lake

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {/* Navigation Buttons */}
      <div
        style={{
          position: "absolute",
          marginTop: 16,
          left: 55,
          zIndex: 1000,
          backgroundColor: "rgba(255,255,255,0.9)",
          borderRadius: 8,
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          display: "inline-flex",
          overflow: "hidden",
        }}
      >
        <button
          onClick={() => setActiveMap("factor")}
          style={{
            padding: "8px 16px",
            backgroundColor: activeMap === "factor" ? "#024795" : "transparent",
            color: activeMap === "factor" ? "#fff" : "#024795",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
            borderBottom: activeMap === "factor" ? "3px solid #ff6600" : "none",
            transition: "all 0.3s ease",
          }}
        >
          Climate Map
        </button>
        <button
          onClick={() => setActiveMap("endemicity")}
          style={{
            padding: "8px 16px",
            backgroundColor: activeMap === "endemicity" ? "#024795" : "transparent",
            color: activeMap === "endemicity" ? "#fff" : "#024795",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
            borderBottom: activeMap === "endemicity" ? "3px solid #ff6600" : "none",
            transition: "all 0.3s ease",
          }}
        >
          Endemicity Map
        </button>
        {/* <button
          onClick={() => setActiveMap("lake")}
          style={{
            padding: "8px 16px",
            backgroundColor: activeMap === "lake" ? "#024795" : "transparent",
            color: activeMap === "lake" ? "#fff" : "#024795",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
            borderBottom: activeMap === "lake" ? "3px solid #ff6600" : "none",
            transition: "all 0.3s ease",
          }}
        >
          Lake Map
        </button> */}
        <button
          onClick={() => setActiveMap("water")}
          style={{
            padding: "8px 16px",
            backgroundColor: activeMap === "water" ? "#024795" : "transparent",
            color: activeMap === "water" ? "#fff" : "#024795",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
            borderBottom: activeMap === "water" ? "3px solid #ff6600" : "none",
            transition: "all 0.3s ease",
          }}
        >
          Water Body Map
        </button>
      </div>

      {/* Maps container */}
      <div style={{ height: "100%", width: "100%" }}>
        {activeMap === "factor" && <WeatherMap />}
        {activeMap === "endemicity" && <EndemicityMap />}
        {activeMap === "water" && <WaterBodiesMap />}
        {/* {activeMap === "lake" && <LakeMap />} */}
      </div>
    </div>
  );
}
